import { createVanIconComponent } from "./van"

const Graphic = createVanIconComponent("graphic")
export default Graphic
